import { render, staticRenderFns } from "./TabPermissions.vue?vue&type=template&id=75f54796&"
import script from "./TabPermissions.vue?vue&type=script&lang=js&"
export * from "./TabPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports